// extracted by mini-css-extract-plugin
export default {"header":"DepartmentsHeader_header__aWdka"};